import React from 'react';
import '../styles/OverviewStep.css';
import '../styles/GeneralStyles.css';
import imgStep1 from '../assets/img-step-1.png'

const OverviewStep = ({ nextStep }) => {
  return (
    <div className='container-large'>
        <div className='wrapp-principal-2-columns'>
            
                <div className="column-content-start">
                  <div className='text-n-options'>
                  <h1 className='heading-style-h2 text-align-left '>Cotiza el anillo de tus sueños en solo 7 pasos.</h1>
                    <p className='text-style-small text-align-left text-color-grey'>
                    En Tressor, sabemos que cada historia de amor es única, y tu anillo de compromiso también debería serlo. Por eso, te ofrecemos una herramienta fácil y rápida para personalizar tu elección en solo unos pasos, respaldado por nuestra calidad Tressor. 
                    <br></br>
                    <br></br>
                    Selecciona las características ideales para tu anillo:
                    <ul className='list-overview'>
                      <li>Corte: Desde el clásico redondo hasta el elegante corte cushion, encuentra el estilo que mejor se adapte a tu gusto.</li>
                      <li>Color: Define la tonalidad perfecta del diamante, desde los tradicionales blancos hasta opciones cálidas y sofisticadas.</li>
                      <li>Pureza: Garantizamos calidad y transparencia al elegir el nivel de pureza que refleje lo mejor de tu elección.</li>
                      <li>Quilates: Selecciona el tamaño ideal que se ajuste a tus deseos y presupuesto.</li>
                      <li>Montura: Elige entre diseños modernos, clásicos o personalizados que complementen perfectamente tu diamante.</li>
                    </ul>
                    <br></br>
                    <br></br>
                    Empieza hoy y crea el símbolo perfecto de tu amor eterno. Haz clic en el botón a continuación para cotizar tu anillo de compromiso y dar el primer paso hacia un "sí, acepto"
                    </p>
                  </div>
                    
                    <div className='wrapp-btns-left'>
                    <button 
                      className="button"
                      onClick={nextStep}
                    >
                      Cotizar ahora
                    </button>

                    </div>
                    
                </div>
                <div className="column-image">
                  <img 
                    src={imgStep1 } 
                    alt="Formulario ilustración"
                    className='imgPreviewNoText'
                  />
                </div>
          
        </div>
    
    </div>
    
  );
};

export default OverviewStep;
